import React, { useEffect, useState } from "react";
import Modal from "../../../components/Modals/Modal";
import { axInst, axInstBasic } from "../../../components/Service/Service";

// const fetchChassisData = async (isSearchArn) => {
//   const basicAuth =
//     "Basic " +
//     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}chassisWiseJC`,
//       { isSearchArn },
//       {
//         headers: {
//           Authorization: basicAuth,
//         },
//       }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };
export const fetchChassisData = async (isSearchArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}chassisWiseJC`,{isSearchArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default function Chassis({
  isSearchArn,
  isArn,
  setIsSearchArn,
  isWaterMark,
}) {
  const [totalChassisJCData, setTotalChassisJCData] = useState(null);
  const [isWaterMarkData, setIsWaterMarkData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");

  useEffect(() => {
    if (isSearchArn && isArn) {
      fetchChassisData(isArn)
        .then((data) => {
          setTotalChassisJCData(data);
        })
        .catch((error) => {
          console.error("Error fetching total open JC:", error);
        });
    }
    setIsSearchArn(false);
  }, [isSearchArn, isArn, setIsSearchArn]);

  useEffect(() => {
    setIsWaterMarkData(isWaterMark);
  }, [isWaterMark]);

  const handleOpenModal = async (orderNum) => {
    const basicAuth =
      "Basic " +
      btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

    try {
      // Make the API call and fetch the data
      const res = await axInst.post(
        `${process.env.REACT_APP_API_URL}jcNumDetails`,
        { orderNum },
        {
          headers: {
            Authorization: basicAuth, // Basic authentication header
          },
        }
      );
      // console.log(res.data.result);
      // Update the modal content and open the modal
      const result = res.data.result; // Assuming API returns `result`
      setModalContent(result || `No details available for`);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching JC details:", error);
      setModalContent(`Failed to fetch details for ${orderNum}`);
      setIsModalOpen(true); // Show the modal even on error
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const calculateDateDifferenceInHours = (createdDate) => {
    const today = new Date();
    const itemCreatedDate = new Date(createdDate);
    const timeDifference = today - itemCreatedDate;
    const hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60));
    return hoursDifference;
  };

  const jcTableData = totalChassisJCData
    ? totalChassisJCData.map((item) => ({
        DIVISION: item._source.DIVISION,
        ASSET_NUM: item._source.ASSET_NUM,
        ORDER_NUM: item._source.ORDER_NUM,
        SERVICE_TYPE: item._source.SERVICE_TYPE,
        CREATED_DATE: item._source.CREATED_DATE,
        JC_OPEN_BUCKETS: item._source.JC_OPEN_BUCKETS,
        SRV_DELAY_RSN: item._source.SRV_DELAY_RSN,
        TAT: `${calculateDateDifferenceInHours(
          item._source.CREATED_DATE
        )} hours`,
      }))
    : [];
  return (
    <div className="p-2 relative">
      {isWaterMarkData && (
        <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-50 pointer-events-none">
          <div>{isWaterMarkData.userId}</div>
          <div>{isWaterMarkData.date}</div>
          <div>{isWaterMarkData.ip}</div>
        </div>
      )}
      <div className="overflow-auto h-full">
        <div className="max-h-[250px] overflow-auto">
          <table className="border-collapse w-full border  border-gray-200 mb-2">
            <thead className="sticky text-white top-0 bg-[#2A5775] text-left z-[1]">
              <tr>
                <th className="border border-gray-300 py-2 px-2">JC No.</th>
                <th className="border border-gray-300 px-2 py-2">Chassis No</th>
                <th className="border border-gray-300 px-2 py-2">
                  JC Create Dt
                </th>
                <th className="border border-gray-300 px-2 py-2">
                  Service Type
                </th>
                <th className="border border-gray-300 px-2 py-2">
                  Workshop Name
                </th>
                <th className="border border-gray-300 px-2 py-2">
                  Open for Days
                </th>
                <th className="border border-gray-300 px-2 py-2">
                  Delay Reason
                </th>
                <th className="border border-gray-300 px-2 py-2">TAT</th>
              </tr>
            </thead>
            <tbody>
              {jcTableData.map((item, index) => (
                <tr key={index}>
                  <td
                    className="border border-gray-300 p-2  text-xs text-blue-500 cursor-pointer"
                    onClick={() => handleOpenModal(item.ORDER_NUM)}
                  >
                    {item.ORDER_NUM}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.ASSET_NUM}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.CREATED_DATE}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.SERVICE_TYPE}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.DIVISION}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.JC_OPEN_BUCKETS}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.SRV_DELAY_RSN}
                  </td>
                  <td className="border border-gray-300 p-2 text-xs">
                    {item.TAT}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        content={modalContent}
      />
    </div>
  );
}
